import React from "react";
import {
  Box,
  Button,
  ClickAwayListener,
  InputBase,
  InputLabel,
  MenuItem,
  MenuList,
  Paper,
  Typography
} from "@mui/material";
import SearchIcon from "../../Icons/SearchIcon";
import CachedItems from "./CachedItems";
import styles from "./SearchInput.module.css";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import highlighter from "../../utils/highliter";
import { PulseLoader } from 'react-spinners';

const SearchInput = ({
  handleSearchInputChange,
  loading,
  searchKey,
  handleSearchClick,
  clearSearchResult,
  searchItems,
  getItem,
  errorMessage,
  caches,
  handleCachedItem,
  data,
  hasMore,
  type,
}) => {

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchClick();
    }
  };

  const notFoundText =
    errorMessage === "No CPV code found" ||
    (searchKey.length > 0 && searchKey.length <= 2)
      ? searchKey.length < 3
        ? "Bitte mindestens 3 Zeichen eingeben"
        : "Keine Ergebnisse"
      : null;

  return (
    <ClickAwayListener onClickAway={clearSearchResult}>
      <div className={styles["cpv-search-root"]}>
        <div className={styles["cpv-search-container"]}>
          <div className={styles["cpv-search-inputGroup"]}>
            <InputBase
              id="input-text-input"
              placeholder={
                type === "limitedSelect"
                  ? "max. 5 CPV-Codes eintragen"
                  : "CPV-Code finden"
              }
              value={searchKey}
              onChange={handleSearchInputChange}
              className={styles["cpv-search-input"]}
              onKeyDown={handleInputKeyDown}
              endAdornment={
                <div>
                  {type === "limitedSelect" ? (
                    <InputLabel
                      htmlFor="input-text-input"
                      className={styles["cpv-search-inputLabel"]}
                      variant="outlined"
                    >
                      CPV-Code(s)
                    </InputLabel>
                  ) : null}
                  {((searchKey.length > 2 || !searchKey) &&
                    loading &&
                    data.length < 1) ? (
                    <PulseLoader
                      color="#0a717c"
                      size={10}
                      margin={5}
                      cssOverride={{
                        display: "inline-flex",
                        position: "absolute",
                        top: "17px",
                        right: "40px",
                      }}
                      loading
                      speedMultiplier={1.5}
                    />
                  ) : null}
                  {(searchKey.length > 0 ||
                    (data?.length > 0 && errorMessage === "")) ? (
                    <IconButton
                      className={styles["cpv-search-removeIcon"]}
                      onClick={() => clearSearchResult("remove")}
                    >
                      <ClearIcon
                        className={styles["cpv-search-clearIcon"]}
                      />
                    </IconButton>
                  ) : null}
                </div>
              }
            />

            <Button
              variant="contained"
              className={styles["cpv-search-searchButton"]}
              disableElevation
              onClick={handleSearchClick}
              disableRipple
              sx={{ width: 200 }}
            >
              <SearchIcon fontSize="large" />
            </Button>
          </div>
          <CachedItems
            caches={caches}
            handleCachedItem={handleCachedItem}
          />
        </div>

        {notFoundText && (
          <Paper className={styles["cpv-search-lists"]}>
            <Box>
              {!hasMore && (
                <Typography className={styles["cpv-search-notFound"]}>
                  {searchKey.length < 3 ? (
                    <span className={styles["cpv-search-notFoundData"]}>
                      Bitte mindestens 3 Zeichen eingeben
                    </span>
                  ) : (
                    <span className={styles["cpv-search-notFoundData"]}>
                      Keine Ergebnisse
                    </span>
                  )}
                </Typography>
              )}
            </Box>
          </Paper>
        )}

        {searchItems?.length > 0 &&
          searchKey.length > 0 &&
          !notFoundText && (
            <Paper className={styles["cpv-search-lists"]}>
              <Box sx={{ borderBottom: "1px solid #eee", padding: 2 }}>
                <Typography fontWeight={600} fontSize={14}>
                  Ergebnisse in CPV-Code ({searchItems.length} Treffer)
                </Typography>
              </Box>
              <MenuList
                open={searchItems.length}
                className={styles["cpv-search-listItems"]}
              >
                {searchItems.map((item) => (
                  <MenuItem
                    key={item.code}
                    className={styles["cpv-search-listItemDrop"]}
                    onClick={() => getItem(item)}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: highlighter(searchKey, item.code),
                      }}
                    />
                    <Typography
                      variant="inherit"
                      className={styles["cpv-search-description"]}
                      dangerouslySetInnerHTML={{
                        __html: highlighter(
                          searchKey,
                          item.description
                        ),
                      }}
                      noWrap
                    />
                  </MenuItem>
                ))}
              </MenuList>
              <div
                className={styles["cpv-search-listAll"]}
                onClick={handleSearchClick}
              >
                Alle Abteilungen Anzeigen
              </div>
            </Paper>
          )}
      </div>
    </ClickAwayListener>
  );
};

export default SearchInput;
